// extracted by mini-css-extract-plugin
module.exports = {"title":"CreateProject_title__I243L","buttons":"CreateProject_buttons__m-_1-","tabs":"CreateProject_tabs__1pVJ8"};